var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pos_settings" },
    [
      _vm._l(_vm.basic_params, function (key_val, key_name) {
        return key_name.length > 0 && _vm.is_text_field(key_name)
          ? _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.__t(key_name.toUpperCase())) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "input-group input-group-lg bg-white shadow-inset-2 with_icon",
                },
                [
                  _vm._m(0, true),
                  _vm._v(" "),
                  _c("b-form-input", {
                    key: key_name,
                    staticClass: "form-control bg-transparent pl-5",
                    attrs: {
                      debounce: "300",
                      state: _vm.is_valid_key(_vm.basic_params[key_name]),
                      id: "basic_param_" + key_name,
                    },
                    on: {
                      update: function ($event) {
                        return _vm.on_change_value(key_name)
                      },
                    },
                    model: {
                      value: _vm.basic_params[key_name],
                      callback: function ($$v) {
                        _vm.$set(_vm.basic_params, key_name, $$v)
                      },
                      expression: "basic_params[key_name]",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e()
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.__t("POS_FILTER_CATEG")) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "imc_reasons",
            attrs: { taggable: "", multiple: "" },
            model: {
              value: _vm.categories,
              callback: function ($$v) {
                _vm.categories = $$v
              },
              expression: "categories",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm.basic_params.hasOwnProperty("send_price")
          ? _c(
              "div",
              { staticClass: "col-4 col-lg-4 col-sm-4 col-md-4" },
              [
                _c("yes_no", {
                  key: "POS_SEND_ORDER_PRICE",
                  attrs: { title: "POS_SEND_ORDER_PRICE" },
                  model: {
                    value: _vm.basic_params.send_price,
                    callback: function ($$v) {
                      _vm.$set(_vm.basic_params, "send_price", $$v)
                    },
                    expression: "basic_params.send_price",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.basic_params.hasOwnProperty("send_full_price")
          ? _c(
              "div",
              { staticClass: "col-4 col-lg-4 col-sm-4 col-md-4" },
              [
                _c("yes_no", {
                  key: "POS_ORDER_ALWAYS_FULL_PRICE",
                  attrs: { title: "POS_ORDER_ALWAYS_FULL_PRICE" },
                  model: {
                    value: _vm.basic_params.send_full_price,
                    callback: function ($$v) {
                      _vm.$set(_vm.basic_params, "send_full_price", $$v)
                    },
                    expression: "basic_params.send_full_price",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.basic_params.hasOwnProperty("load_all_organizations")
          ? _c(
              "div",
              { staticClass: "col-4 col-lg-4 col-sm-4 col-md-4" },
              [
                _c("yes_no", {
                  key: "POS_LOAD_ALL_ORG",
                  attrs: { title: "POS_LOAD_ALL_ORG" },
                  model: {
                    value: _vm.basic_params.load_all_organizations,
                    callback: function ($$v) {
                      _vm.$set(_vm.basic_params, "load_all_organizations", $$v)
                    },
                    expression: "basic_params.load_all_organizations",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.basic_params.hasOwnProperty("as_delivery")
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-4 col-lg-4 col-sm-4 col-md-4" },
              [
                _c("yes_no", {
                  key: "POS_SEND_ORDER_AS_DELIVERY",
                  attrs: { title: "POS_SEND_ORDER_AS_DELIVERY" },
                  model: {
                    value: _vm.basic_params.as_delivery,
                    callback: function ($$v) {
                      _vm.$set(_vm.basic_params, "as_delivery", $$v)
                    },
                    expression: "basic_params.as_delivery",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mt-4" }, [
        _c("div", { staticClass: "panel-tag mb-1" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.__t("SYNC_POS_DATA")) + "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _vm.basic_params.hasOwnProperty("sync_stop")
            ? _c(
                "div",
                { staticClass: "col-4 col-lg-4 col-sm-4 col-md-4" },
                [
                  _c("yes_no", {
                    key: "SYNC_POS_STOP_LIST",
                    attrs: { title: "SYNC_POS_STOP_LIST" },
                    model: {
                      value: _vm.basic_params.sync_stop,
                      callback: function ($$v) {
                        _vm.$set(_vm.basic_params, "sync_stop", $$v)
                      },
                      expression: "basic_params.sync_stop",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.basic_params.hasOwnProperty("sync_order_state")
            ? _c(
                "div",
                { staticClass: "col-4 col-lg-4 col-sm-4 col-md-4" },
                [
                  _c("yes_no", {
                    key: "SYNC_POS_ORDER_STATE",
                    attrs: { title: "SYNC_POS_ORDER_STATE" },
                    model: {
                      value: _vm.basic_params.sync_order_state,
                      callback: function ($$v) {
                        _vm.$set(_vm.basic_params, "sync_order_state", $$v)
                      },
                      expression: "basic_params.sync_order_state",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.basic_params.hasOwnProperty("full_sync_modifier")
            ? _c(
                "div",
                { staticClass: "col-4 col-lg-4 col-sm-4 col-md-4" },
                [
                  _c("yes_no", {
                    key: "FULL_SYNC_MODIFIER",
                    attrs: { title: "FULL_SYNC_MODIFIER" },
                    model: {
                      value: _vm.basic_params.full_sync_modifier,
                      callback: function ($$v) {
                        _vm.$set(_vm.basic_params, "full_sync_modifier", $$v)
                      },
                      expression: "basic_params.full_sync_modifier",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.basic_params.hasOwnProperty("push_rest_title_in_comment")
            ? _c(
                "div",
                { staticClass: "col-4 mt-2 col-lg-4 col-sm-4 col-md-4" },
                [
                  _c("yes_no", {
                    key: "PUSH_REST_TITLE_COMMENT",
                    attrs: { title: "PUSH_REST_TITLE_COMMENT" },
                    model: {
                      value: _vm.basic_params.push_rest_title_in_comment,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.basic_params,
                          "push_rest_title_in_comment",
                          $$v
                        )
                      },
                      expression: "basic_params.push_rest_title_in_comment",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.basic_params.hasOwnProperty("lock_categories_tree_update")
            ? _c(
                "div",
                { staticClass: "col-4 mt-2 col-lg-4 col-sm-4 col-md-4" },
                [
                  _c("yes_no", {
                    key: "LOCK_CATEGORIES_TREE_UPDATE",
                    attrs: { title: "LOCK_CATEGORIES_TREE_UPDATE" },
                    model: {
                      value: _vm.basic_params.lock_categories_tree_update,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.basic_params,
                          "lock_categories_tree_update",
                          $$v
                        )
                      },
                      expression: "basic_params.lock_categories_tree_update",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.basic_params.hasOwnProperty("push_stop_by_name")
            ? _c(
                "div",
                { staticClass: "col-4 mt-2 col-lg-4 col-sm-4 col-md-4" },
                [
                  _c("yes_no", {
                    key: "PUSH_STOP_BY_NAME",
                    attrs: { title: "PUSH_STOP_BY_NAME" },
                    model: {
                      value: _vm.basic_params.push_stop_by_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.basic_params, "push_stop_by_name", $$v)
                      },
                      expression: "basic_params.push_stop_by_name",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c(
        "span",
        {
          staticClass:
            "input-group-text bg-transparent border-left-0 border-right-0 py-1 px-3",
        },
        [
          _c("span", { staticClass: "icon-stack fs-xxl" }, [
            _c("i", { staticClass: "base-7 icon-stack-3x color-primary-500" }),
            _vm._v(" "),
            _c("i", {
              staticClass: "fal fa-database icon-stack-1x text-white",
            }),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }